// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Faroe Islands */
const FO = /^(?:(?:[27][1-9]|5\d|9[16])\d{4})$/;

export default FO;
